import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getOrderTypesData = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/order-types/`)
        // console.log('eff res', response)
        return await response.data
    } catch (error) {
        console.log("getOrderTypesData - error", error)
        return handleApiError(error)
    }
}